import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/Enlightenment_&_Revolutions_-_Age_of_Enlightenment.png';

function HistoryPageAgeOfEnlightenmentGo() {
  return (
    <QuizPage
      title="History: Age of Enlightenment"
      subTopic="Age of Enlightenment"
      backgroundImage={historyImage}
      returnPath="/History-Age-of-Enlightenment"
    />
  );
}

export default HistoryPageAgeOfEnlightenmentGo;
